import generalActionTypes from './action-types';

export const fetchCampaignInsights = value => ({
  type: generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS,
  payload: value,
});

export const fetchCampaignInsightsSuccess = value => ({
  type: generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS_SUCCESS,
  payload: value,
});

export const fetchCampaignInsightsFail = value => ({
  type: generalActionTypes.FETCH_CAMPAIGNS_INSIGHTS_FAIL,
  payload: value,
});
